import { Component, EventEmitter, Input, Output } from '@angular/core'
import { CAcademyFormation } from '../../interfaces/c-academy-formation'
import { DatePipe, NgClass, NgForOf, NgIf } from '@angular/common'
import { TranslateModule } from '@ngx-translate/core'
import { StarsRatingComponent } from '@components/stars-rating/stars-rating.component'
import { ButtonComponent } from '@components/button/button.component'
import { Router } from '@angular/router'
import { ApiService } from '../../services/api.service'
import { LoadingService } from '../../services/loading.service'
import { AnalyticsService } from 'app/services/analytics.service'

@Component({
  selector: 'app-c-academy-card',
  standalone: true,
    imports: [
        NgIf,
        DatePipe,
        TranslateModule,
        StarsRatingComponent,
        NgForOf,
        ButtonComponent,
        NgClass
    ],
  templateUrl: './c-academy-card.component.html',
  styleUrl: './c-academy-card.component.scss'
})
export class CAcademyCardComponent {
    @Input() fullWidth: boolean = false;
    @Input() formation: CAcademyFormation;
    @Output() onUpdate: EventEmitter<void> = new EventEmitter<void>();

    constructor(private router: Router, private api: ApiService, private loading: LoadingService, private analytics: AnalyticsService) {
    }

    getBrandIconSrc(brand: string) {
        brand = brand.toLowerCase();
        switch (brand) {
            case 'dekton':
                return 'assets/icons/brands/dekton-black.svg';
            case 'silestone':
                return 'assets/icons/brands/silestone-black.svg';
            case 'sensa':
                return 'assets/icons/brands/sensa-black.svg';
            case 'scalea':
                return 'assets/icons/brands/scalea-black.svg';
            case 'prexury':
                return 'assets/icons/brands/prexury-black.svg';
            default:
                return null;
        }
    }

    getActionType(): 'start-training' | 'continue-training' | 'view-again' {
        if (this.formation.completedAt) return 'view-again';
        if (this.formation.isStarted) return 'continue-training';
        return 'start-training';
    }


    goToFormation(){
        this.analytics.trackClick(this.getActionType(), undefined, { type: this.formation.title });

        console.log('Going to formation', this.formation.id)
        if(!this.formation.isStarted){
            this.loading.show()
            this.api.setFormationStarted(this.formation.id).subscribe((response) => {
                if(response) {
                    this.formation.isStarted = true;
                }
                this.loading.hide()
                this.router.navigate(['c-academy', this.formation.id])
            })
        } else {
            this.router.navigate(['c-academy', this.formation.id])
        }
    }

    toggleFavourite() {
        console.log('Toggle favourite', this.formation.id)
        this.loading.show()
        this.api.toggleFormationFavourite(this.formation.id).subscribe((response) => {
            if(response){
                this.formation.isFavourite = !this.formation.isFavourite;
                this.onUpdate.emit();
            }
            this.loading.hide()
        })
    }
}
